import { Component, Input, OnInit } from '@angular/core';
import { NAVIGATION_REQUEST_STATUSES } from '../../../../../reporting/analytics-core/interfaces/configuration.interface';
import * as jQuery from 'jquery';
import * as _ from 'underscore';

import { EmitterService } from '../../../../../core/utility/services/emitter.service';
import { UtilityService } from '../../../../../core/utility/services/utility.service';
import {
	EVENT_EMITTERS,
	PRINTABLE_ACCESS_KEYS,
	PRISTINE_PERMISSIONS
} from '../../../../analytics/constants/analytics.constants';
import { AnalyticsDataModel } from '../../../../analytics/models/analytics.datamodel';
import { AnalyticsService } from '../../../../analytics/services/analytics.service';
import { WidgetCore } from '../../../../widget-library/interfaces/widget.core.interface';
import { AnalyticsDataChachingService } from '../../../../analytics/services/analytics.datacaching.service';
import { AnalyticsMixpanelService } from '../../../../analytics/services/analytics.mixpanel.service';

@Component({
	selector: 'app-nav-card',
	styleUrls: ['./nav-card.component.css'],
	templateUrl: './nav-card.component.html'
})
export class NavCardComponent implements OnInit, WidgetCore {
	@Input() sectiontitle: string;
	@Input() sectionpath: string;
	@Input() sectionclass: string;
	@Input() key: string;
	@Input() secondarykey: string;
	@Input() legend: any;
	@Input() columnsconfig: any;
	@Input() issecondarykeyendpoint: any;
	@Input() uniqueoverwriteid: string;
	@Input() getdatafromwidget: string;
	public widgetIdProcesReq: string;
	public columns: any;
	public oninItFlag: boolean = false;
	public productCount;
	public disabledimage: string;
	public isDisabled = true;
	public isActive = false;
	public statsEnabled: boolean = false;
	public showLoader: boolean = true;
	public productCampaignsActiveCount: any = 0;
	public allow: boolean = true;
	public isR13: boolean = false;
	public isLeeR13: boolean = false;
	public isGAM: boolean = false;

	constructor(
		protected analyticsDataModel: AnalyticsDataModel,
		protected analyticsService: AnalyticsService,
		protected AnalyticsDataChachingService: AnalyticsDataChachingService,
		protected analyticsMixpanelService: AnalyticsMixpanelService
	) {
		EmitterService.get(EVENT_EMITTERS.NAVIGATE).subscribe(() => {
			this.isActive = false;
		});
		EmitterService.get(EVENT_EMITTERS.RELOAD).subscribe(() => {
			this.showLoader = true;
			this.requestData();
		});
		EmitterService.get(EVENT_EMITTERS.NAVIGATION_DONE).subscribe((response: any) => {
			setTimeout(() => {
				this.isActive =
					this.analyticsDataModel.getCurrentPath() &&
					this.analyticsDataModel.getCurrentPath().length &&
					this.analyticsDataModel.getCurrentPath() === this.sectionpath;
			}, 100);
		});
	}

	ngOnInit(): void {
		this.isActive =
			this.analyticsDataModel.getCurrentPath() &&
			this.analyticsDataModel.getCurrentPath().length &&
			this.analyticsDataModel.getCurrentPath() === this.sectionpath;
		if (this.legend) {
			this.legend = JSON.parse(decodeURI(this.legend));
			if (this.analyticsDataModel.config.version.toLowerCase() === 'r10') {
				this.legend = _.filter(this.legend, (item) => {
					return this.analyticsDataModel.checkComponentForPermission(item);
				});
			}
			this.statsEnabled = this.legend.length > 0 ? true : false;
		}
		if (this.columnsconfig) {
			this.columns = JSON.parse(decodeURI(this.columnsconfig));
		}
		this.isR13 = this.analyticsDataModel.config.directoryName.toLowerCase() === 'default-r13';
		this.isLeeR13 = this.analyticsDataModel.config.directoryName.toLowerCase() === 'lee-r13';
		this.isGAM = this.sectiontitle.toLocaleLowerCase() == 'gam';
		this.requestData();
		this.oninItFlag = true;
		setTimeout(() => {
			this.oninItFlag = false;
		}, 5000);
	}

	requestData(): void {
		this.analyticsDataModel.navigateProcessRequestStatus[this.sectionpath] = NAVIGATION_REQUEST_STATUSES.IN_PROGRESS;
		this.showLoader = true;
		if (this.analyticsDataModel.selectedCampaigns.length <= 0) {
			this.isDisabled = true;
			EmitterService.get(EVENT_EMITTERS.UPDATE_OVERVIEW_REPORT_DETAILS).emit(
				this.analyticsDataModel.overViewReportDetails
			);
		}
		if (this.key !== '') {
			this.analyticsService.processWidgetRequest(this.key).subscribe((response: any) => {
				if (response.success) {
					this.processResponseData(response);
					this.widgetIdProcesReq =
						!this.widgetIdProcesReq && this.getdatafromwidget && this.getdatafromwidget != 'undefined'
							? !this.AnalyticsDataChachingService.checkSelectionsChanges(this.getdatafromwidget)
								? this.AnalyticsDataChachingService.ANALYTICS_WIDGETS_CACHED_DATA.data[this.getdatafromwidget]?.[
										'response'
								  ]
									? this.getdatafromwidget
									: this.uniqueoverwriteid
								: this.uniqueoverwriteid
							: this.uniqueoverwriteid;
					if (this.issecondarykeyendpoint == 'true') {
						this.analyticsService
							.processCustomServiceRequest(this.secondarykey, null, null, null, null, this.widgetIdProcesReq)
							.subscribe((res: any) => {
								this.showLoader = false;
								const res_data = res.success ? res.data[0] : [];
								this.processQuickStatsData(res_data);
							});
					} else {
						this.analyticsService
							.processWidgetRequest(this.secondarykey, this.columns, null, this.widgetIdProcesReq)
							.subscribe((res: any) => {
								this.showLoader = false;
								const res_data = res.success ? res.data[0] : [];
								this.processQuickStatsData(res_data);
							});
					}
				} else {
					if (this.analyticsDataModel.overViewReportDetails.includes(this.sectiontitle)) {
						this.analyticsDataModel.overViewReportDetails.splice(
							this.analyticsDataModel.overViewReportDetails.indexOf(this.sectiontitle),
							1
						);
					}
					this.showLoader = false;
				}
			});
		} else {
			if (
				this.sectiontitle === 'Overview' &&
				this.analyticsDataModel.selectedCampaigns.length > 0 &&
				this.analyticsDataModel.selectedAdvertisers.length > 0
			) {
				this.isDisabled = false;
			}
			setTimeout(() => {
				this.isActive =
					this.analyticsDataModel.getCurrentPath() &&
					this.analyticsDataModel.getCurrentPath().length &&
					this.analyticsDataModel.getCurrentPath() === this.sectionpath;
			}, 100);
			this.analyticsDataModel.navigateProcessRequestStatus[this.sectionpath] = NAVIGATION_REQUEST_STATUSES.COMPLETED;
		}
	}

	processResponseData(responseData: any): void {
		const data = responseData.data.length ? responseData.data[0] : {};
		if (data.status && !!parseInt(data.status, 10)) {
			this.isDisabled = false;
			if (!this.analyticsDataModel.overViewReportDetails.includes(this.sectiontitle)) {
				this.analyticsDataModel.overViewReportDetails.push(this.sectiontitle);
				EmitterService.get(EVENT_EMITTERS.UPDATE_OVERVIEW_REPORT_DETAILS).emit(
					this.analyticsDataModel.overViewReportDetails
				);
			}
		} else {
			this.isDisabled = true;
			if (this.analyticsDataModel.overViewReportDetails.includes(this.sectiontitle)) {
				this.analyticsDataModel.overViewReportDetails.splice(
					this.analyticsDataModel.overViewReportDetails.indexOf(this.sectiontitle),
					1
				);
			}
		}
		setTimeout(() => {
			EmitterService.get(EVENT_EMITTERS.NAVIGATION_STATUS).emit({
				isDisabled: this.isDisabled,
				path: this.sectionpath
			});
			this.analyticsDataModel.navigateProcessRequestStatus[this.sectionpath] = NAVIGATION_REQUEST_STATUSES.COMPLETED;
			this.navigateAwayIfPathDisabled();
		}, 1000);
	}

	processQuickStatsData(responseData: any): void {
		for (const legendObj of this.legend) {
			legendObj['noData'] = UtilityService.isUndefinedOrNull(responseData[`${legendObj.value}`]) ? true : false;
			legendObj['data'] = UtilityService.isUndefinedOrNull(responseData[`${legendObj.value}`])
				? null
				: responseData[`${legendObj.value}`];
			if (legendObj.percentValue) {
				legendObj['percentData'] = UtilityService.isUndefinedOrNull(responseData[`${legendObj.percentValue}`])
					? null
					: responseData[`${legendObj.percentValue}`];
			}
		}
	}

	navigateAwayIfPathDisabled(): void {
		if (this.isDisabled && this.isActive) {
			EmitterService.get(EVENT_EMITTERS.NAVIGATE).emit({ name: this.analyticsDataModel.config.routing.defaultRoute });
		}
	}

	navigate(): void {
		this.allow = false;
		setTimeout(() => {
			this.allow = true;
		}, 500);

		if (
			!this.isDisabled &&
			this.analyticsDataModel.selectedCampaigns.length > 0 &&
			this.analyticsDataModel.selectedAdvertisers.length > 0
		) {
			EmitterService.get(EVENT_EMITTERS.NAVIGATE).emit({ name: this.sectionpath });
			EmitterService.get(EVENT_EMITTERS.TOGGLE_LEFTPANE).emit(true);
		}

		this.analyticsMixpanelService.mixpanelData('Analytics / ' + this.sectiontitle + ' Sidebar Product Clicked');
	}
}
